<template>
  <div>
    <template v-if="showChooser">
      <button
        @click="showFinder"
        v-if="boxChooser"
        class="btn btn-xs btn-secondary btn-uppercase mg-l-auto mg-t-10 task-finder-action-unlink"
      >
        <feather type="link"></feather>холбох
      </button>
      <template v-else>
        <div v-if="selectedId != null">
          <a @click="showFinder" role="button" class="tx-brand-01">{{
            taskModel.task
          }}</a>
          <span
            class="btn btn-danger btn-xs text-white pd-0 btn-uppercase"
            style="margin-top: -20px;"
            role="button"
            @click="emitNull"
          >
            <feather type="x"></feather>
          </span>
        </div>

        <button
          @click="showFinder"
          v-else
          type="button"
          class="btn btn-xs btn-outline-primary btn-block"
        >
          сонгоно уу...
        </button>
      </template>
    </template>
    <template v-if="finderShow">
      <b-sidebar
        id="sidebar-right"
        title="Шинэ"
        right
        shadow
        backdrop
        v-model="showSidebar"
        :width="sidebarWidth"
        @change="visibleChanged"
        :no-close-on-backdrop="true"
        :no-header="true"
        :no-header-close="true"
      >
        <b-overlay :show="loading" rounded="sm">
          <core-list
            class="bg-white"
            :key="finderKey"
            :prms.sync="prms"
            :prmsProp.sync="prmsProp"
            @on-task-selected="taskSelected($event)"
            @on-close="visibleChanged(false)"
            @on-fetched="loading = false"
          ></core-list>
        </b-overlay>
      </b-sidebar>
    </template>
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    coreList: () => ({
      component: import("@/views/apps/vet-med/list.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    showSidebar: false,
    prms: {},
    finderShow: false,
    taskModel: {},
    loading: true,
    finderKey: 0
  }),
  props: {
    mode: {
      type: Number,
      default: () => 50
    },
    prmsProp: {
      type: Object,
      default: () => {}
    },
    objectTypeId: {
      type: String,
      default: () => "0"
    },
    fieldName: {
      type: String,
      default: () => "0"
    },
    selectedId: {
      type: Number,
      default: () => null
    },
    parentTaskId: {
      type: Number,
      default: () => null
    },
    boxChooser: {
      type: Boolean,
      default: () => false
    },
    showChooser: {
      type: Boolean,
      default: () => true
    },
    sidebarWidth: {
      type: String,
      default: () => "100%"
    }
  },
  mounted() {
    if (this.selectedId != null && this.selectedId != 0) {
      request({
        params: { id: this.selectedId },
        api: { url: "task/getInherited", method: "get" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.taskModel = res.data.task;
          this.$emit("on-task-selected", res.data.task);
        }
      });
    }
  },
  methods: {
    //...mapActions(["handleLoading"]),
    init() {
      this.finderShow = true;
      this.prms.objectTypeId = parseInt(this.objectTypeId, 10);
      this.prms.mode = this.mode;
      
      if(this.fieldName!=undefined){
        this.prms.fieldName = this.fieldName;
      }

      this.showSidebar = true;
      this.$nextTick(() => {
        //this.finderKey++;
      });

      this.prms.parentTaskId= this.parentTaskId;
    },
    emitNull() {
      if(this.hasPerr(['stf_proj_sudlaach']) && !this.hasPerr(['stf_proj_shinjeech', 'stf_proj_admin'])){
        Notification.warning({
          message: `Үйлдлийг гүйцэтгэх боломжгүй !`,
          duration: 5000
        });
      }else{
        this.$emit("input", null);
      }
      //console.log("null emiited");
      
    },
    hasPerr(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    taskSelected(e) {
      //console.log('step #1 taskSelected=> ', e, e.task, e.objectTypeId);
      this.finderShow = false;
      this.$nextTick(() => {
        this.showSidebar = false;
        this.taskModel.task = e.obj.task;
        this.$emit("input", e.obj.id);
        this.$emit("on-task-selected", e.obj);
        this.$emit("on-finder-close");
      });
    },
    visibleChanged(e) {
      if (!e) {
        //Object.assign(this.$data, this.$options.data());
        this.finderShow = false;
        this.$nextTick(() => {
          this.$emit("on-finder-close");
          this.showSidebar = false;
        });
      }
    },
    showFinder() {
      this.init();
    }
  }
};
</script>
